module.exports = "<div id=\"loading\" *ngIf=\"loading\">\n  <div class='loader'>\n    <div class='loader--dot'></div>\n    <div class='loader--dot'></div>\n    <div class='loader--dot'></div>\n    <div class='loader--dot'></div>\n    <div class='loader--dot'></div>\n    <div class='loader--dot'></div>\n    <div class='loader--text'></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/loader/loader.component.html
// module id = ../../../../../src/app/component/loader/loader.component.html
// module chunks = main